import { useMemo, useState, useContext } from "react"
import { UserContext } from "../../store/store"

import { limits } from "../../services/statics"
import useFetch from "../../hooks/useFetch"
import { api } from "../../services/api"

import { Paginator } from "../../components/ui/Paginator"
import { getCookie } from "../../helpers/cookies"
import { config } from "../../config"
import { useTranslation } from "react-i18next"

export const Historial = () => {
  // state
  const [limit, setLimit] = useState(config.default_limit),
    [offest, setOffset] = useState(1)

  const tkn = getCookie("jwt"),
    { url, opt } = useMemo(
      () =>
        api.commits.readAll({
          token: tkn,
          from: offest,
          limit,
        }),
      [tkn, limit, offest]
    )
  const [data, isPending, err] = useFetch({ url, opt })

  const { t } = useTranslation()

  return (
    <>
      <div className="col-10" style={{ margin: "0 auto" }}>
        <h4>{t(`admin.system.log_history`)}</h4>

        <div className="d-flex justify-content-end align-items-center flex-row pb-3">
          <div className="form-check">
            <label className="form-check-label">
              {t(`ui.tables.limit`)}
              <select
                className="form-select mini-select mx-2"
                value={limit}
                onChange={(e) => setLimit(parseInt(e.target.value))}
                defaultValue={100}
                style={{ fontSize: "14px" }}
              >
                {limits.map((lim, ix) => (
                  <option key={ix} value={lim}>
                    {lim}
                  </option>
                ))}
              </select>
            </label>
          </div>
        </div>

        {isPending && <p className="my-3">{t(`ui.btns.loading`)}...</p>}
        {err && <p className="my-3">{t(`ui.msgs.something_went_wrong`)}</p>}
        {!isPending && data && <ListCommits commits={data.entries} />}

        {!isPending && !err && (
          <Paginator
            total={data.total}
            offset={offest}
            radius={3}
            skipers={false}
            iterators={false}
            setOffset={setOffset}
            pageSize={limit}
          />
        )}
      </div>
    </>
  )
}

const ListCommits = ({ commits }) => {
  const [state] = useContext(UserContext)
  const theme = state.theme === "light" ? "table-striped" : "table-dark"

  const { t } = useTranslation()

  return (
    <table className={"table table-hover " + theme}>
      <thead>
        <tr>
          <th>ID</th>
          <th>{t(`ui.tables.author`)}</th>
          <th>{t(`admin.system.data`)}</th>
          <th>
            <center>{t(`ui.tables.date`)}</center>
          </th>
        </tr>
      </thead>
      <tbody style={{ borderTop: "2px solid #4e4e4e" }}>
        {commits.map((commit, ix) => (
          <tr key={ix}>
            <td>{commit.id}</td>
            <td>
              <i>{commit.author.username}</i>
            </td>
            <td style={{ width: "70%" }}>
              <pre
                className="mb-0"
                style={{
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                }}
              >
                {JSON.stringify(commit.data, null, 2)
                  .slice(2, -2)
                  .replace(/[{},"]/g, "")
                  .replace(/\n\s*\n/g, "\n")}
              </pre>
            </td>
            <td>
              <center>{commit.timestamp.slice(0, 10)}</center>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
